// Parappa roots
export const PROD_PARAPPA_DATA_ROOT = 'https://static.prd.plusreed.co/parappa-data/'
export const TEST_PARAPPA_DATA_ROOT = 'https://static.tst.plusreed.co/parappa-data/'
export const DEV_PARAPPA_DATA_ROOT = 'https://static.dev.plusreed.co/parappa-data/'

export const ENABLE_SERVICES_PAGE = !!(process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test')
